module.exports = __webpack_public_path__ + "img/logo.365c7c3a.svg";